import { formatCardNumber } from "@/common/utils/formatters";
import Button from "../Button";
import { useCopyButton } from "@/common/hooks/useCopyButton";
import { useCardWithSecureInformation } from "@/common/hooks/queries/useCardWithSecureInformation";
import { CopyButton } from "../CopyButton";

interface CardNumberWithCopyButtonProps {
  card: {
    id: string;
    last_four_digits: string;
  };
}

const CardNumberWithCopyButton = ({ card }: CardNumberWithCopyButtonProps) => {
  const { control, copySuccess, copyFailed } = useCopyButton();

  const {
    mutate: personalCard,
  } = useCardWithSecureInformation({
    onSuccess: (response) => copySuccess(response?.data?.data?.number),
    onError: copyFailed
  });

  return (
    <div className="flex items-center gap-2">
      <p>
        {formatCardNumber(card.last_four_digits)}
      </p>

      {card.id && (
        <Button variant="link-white" onClick={() => personalCard(card.id)}>
          <CopyButton
            control={control}
            operationKlassToCheckPermission="Admin::Client::Cards::ShowWithSecureInformation"
            className="text-blue-800 outline-none"
          />
        </Button>
      )}
    </div>
  );
}

export default CardNumberWithCopyButton;
